export default "__VITE_ASSET__DsGczdwp__"